import React, { useState, useEffect } from 'react';
import './BentoBoxes.css';

const BentoBoxes = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 34,
    seconds: 15
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let { hours, minutes, seconds } = prev;
        
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        
        return { hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="bento-container">
      <div className="bento-wrapper">
        {/* Pre-market 24h Vol */}
        <div className="bento-box">
          <div className="bento-header">
            <span className="bento-title">Pre-market 24h Vol</span>
          </div>
          <div className="bento-content">
            <div className="volume-top">
              <div className="volume-main">$4.2M</div>
              <div className="volume-change positive">+12.5%</div>
            </div>
            <div className="mini-chart">
              <svg width="100%" height="40" viewBox="0 0 120 40" preserveAspectRatio="none">
                <defs>
                  <linearGradient id="chartGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor="#22c55e" stopOpacity="0.3"/>
                    <stop offset="100%" stopColor="#22c55e" stopOpacity="0"/>
                  </linearGradient>
                </defs>
                <path
                  d="M0,35 L8,30 L16,32 L24,25 L32,28 L40,20 L48,24 L56,15 L64,18 L72,10 L80,14 L88,8 L96,12 L104,6 L112,4 L120,1"
                  stroke="#22c55e"
                  strokeWidth="2"
                  fill="none"
                />
                <path
                  d="M0,35 L8,30 L16,32 L24,25 L32,28 L40,20 L48,24 L56,15 L64,18 L72,10 L80,14 L88,8 L96,12 L104,6 L112,4 L120,1 L120,40 L0,40 Z"
                  fill="url(#chartGradient)"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* Fear & Greed */}
        <div className="bento-box">
          <div className="bento-header">
            <span className="bento-title">Fear & Greed</span>
          </div>
          <div className="bento-content">
            <div className="gauge-container">
              <div className="gauge-wrapper">
                <svg width="200" height="120" viewBox="0 0 200 120">
                  <defs>
                    <linearGradient id="gaugeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop offset="0%" stopColor="#ef4444"/>
                      <stop offset="25%" stopColor="#f59e0b"/>
                      <stop offset="50%" stopColor="#eab308"/>
                      <stop offset="75%" stopColor="#84cc16"/>
                      <stop offset="100%" stopColor="#22c55e"/>
                    </linearGradient>
                  </defs>
                  
                  {/* Background arc */}
                  <path
                    d="M 30 90 A 70 70 0 0 1 170 90"
                    stroke="#333333"
                    strokeWidth="12"
                    fill="none"
                    strokeLinecap="round"
                  />
                  
                  {/* Colored arc */}
                  <path
                    d="M 30 90 A 70 70 0 0 1 170 90"
                    stroke="url(#gaugeGradient)"
                    strokeWidth="12"
                    fill="none"
                    strokeLinecap="round"
                  />
                  
                  {/* White indicator dot at 51% position */}
                  <circle cx="100" cy="25" r="6" fill="#ffffff" stroke="#2a2a2a" strokeWidth="2"/>
                </svg>
                <div className="gauge-center">
                  <div className="gauge-value">51</div>
                  <div className="gauge-label">Neutral</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Altcoin Season */}
        <div className="bento-box">
          <div className="bento-header">
            <span className="bento-title">Altcoin Season</span>
          </div>
          <div className="bento-content">
            <div className="altcoin-score">66<span className="score-total">/100</span></div>
            <div className="progress-container">
              <div className="progress-labels">
                <span className="progress-label left">Bitcoin</span>
                <span className="progress-label right">Altcoin</span>
              </div>
              <div className="progress-bar">
                <div className="progress-indicator" style={{ left: '66%' }}></div>
              </div>
            </div>
          </div>
        </div>

        {/* Settlement Countdown */}
        <div className="bento-box settlement-card">
          <div className="bento-header">
            <span className="bento-title">Next Settlement</span>
          </div>
          <div className="bento-content">
            <div className="settlement-title">2Z</div>
            <div className="countdown-new">
              <div className="time-unit-new">
                <div className="time-value-new">00</div>
              </div>
              <div className="time-separator-new">:</div>
              <div className="time-unit-new">
                <div className="time-value-new">{String(timeLeft.hours).padStart(2, '0')}</div>
              </div>
              <div className="time-separator-new">:</div>
              <div className="time-unit-new">
                <div className="time-value-new">{String(timeLeft.minutes).padStart(2, '0')}</div>
              </div>
              <div className="time-separator-new">:</div>
              <div className="time-unit-new">
                <div className="time-value-new">{String(timeLeft.seconds).padStart(2, '0')}</div>
              </div>
            </div>
            <div className="countdown-labels">
              <span>DAYS</span>
              <span>HOURS</span>
              <span>MINUTES</span>
              <span>SECONDS</span>
            </div>
            <div className="settlement-date">9 SEPTEMBER 2025</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BentoBoxes;
